export function normalizeUrl(url: string): string {
  return url.replace(/(https?:\/\/)|(\/)+/g, '$1$2');
}
